import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';


@Component({
  moduleId: module.id,
  selector: 'profile-input',
  templateUrl: 'profile-input.component.html',
  styleUrls: ['profile-input.component.scss'],
})
export class ProfileInputComponent {
  @Input() form: UntypedFormGroup;
  @Input() fieldName: string;
  @Input() placeholder: string;
  @Input() isPassword: boolean = true;

  errors: any = {
    incorrect: 'This password is not secure enough!',
    notMatch: 'Passwords do not match!',
  };

  // getters
  get type() {
    return this.isPassword ? 'password' : 'text';
  }
}
